import { objectSet } from '../../lib/utils'

const state = {
  config: {
    listPage: {
      displayType: 'grid'
    },
  },
}

const getters = {}

const mutations = {
  setConfig(state, { key, value }) {
    console.debug('vuex.setConfig', { key, value })
    const config = Object.assign({}, state.config)
    objectSet(config, key, value)
    state.config = config
  },
}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions,
}
